<div class="product-modal">
    <div class="row">
        <div class="col-md-12">
            <h1 class="text-center">{{product.name}}</h1>
            <article>
                <p>
                    <img
                        class="productImg"
                        [src]="product.imageUrl"
                    >
                </p>
                <div
                    *ngIf="(product.isHidden || product.isPurchasable) && product.listPrice >= 0"
                    class="text-center"
                >
                    <app-product-price [product]="product"></app-product-price>
                </div>
                <!-- description is different for cael and celpip becasue of the collapsible div -->
                <div
                    class="product-description"
                    *ngIf="brandId === BrandEnum.CELPIP; else CAELproducts"
                >
                    <div *ngIf="!hasNgCollapse; else ngCollapse">
                        <div [innerHTML]="productDescription | safe: 'html'"></div>
                    </div>
                    <ng-template #ngCollapse>
                        <div [innerHTML]="nonCollapsibleDescription | safe: 'html'"></div>
                        <a
                            (click)="collapse.toggle()"
                            [attr.aria-expanded]="!isCollapsed"
                            aria-controls="collapseExample"
                        > Read more </a>
                        <div
                            class="mt-4"
                            #collapse="ngbCollapse"
                            [ngbCollapse]="isCollapsed"
                            [innerHTML]=" collapsibleDescription | safe: 'html'"
                        ></div>
                    </ng-template>
                </div>
                <ng-template #CAELproducts>
                    <div [innerHTML]="productDescription | safe: 'html'"></div>
                </ng-template>
            </article>
            <br />
        </div>
        <div class="col-md-12">
            <div
                *ngIf="!canBuyForChild; else BusinessAccountWithChildren"
                class="btn-toolbar pull-right"
            >
                <div>
                    <button
                        type="button"
                        class="btn btn-primary m-1"
                        *ngIf="freeForDownload"
                        (click)="downloadPdf(product)"
                    >
                        <i class="fa fa-shopping-cart"></i>
                        Free Download
                    </button>
                    <button
                        type="button"
                        class="btn btn-primary m-1"
                        *ngIf="(product.isHidden || product.isPurchasable) && product.listPrice > 0"
                        (click)="onAddItemToCart(product)"
                    >
                        <i class="fa fa-shopping-cart"></i>
                        Add to Cart
                    </button>
                </div>
                <button
                    (click)="onContinue()"
                    type="button"
                    class="btn btn-primary m-1"
                >
                    Continue shopping
                </button>
            </div>
            <ng-template #BusinessAccountWithChildren>
                <app-product-business-account
                    [childAccounts]="childAccounts"
                    [canPurchase]="product.isPurchasable"
                    (add)="onBatchAddItemToCart($event)"
                    (continue)="onContinue()"
                >
                </app-product-business-account>
            </ng-template>
        </div>
        <div class="col-md-12">
            <app-product-bundles
                [product]="product"
                [brandId]="brandId"
                [isRegFlow]="isRegFlow"
            >
            </app-product-bundles>
        </div>
    </div>
</div>
